import React, { useState, useRef, useEffect } from 'react';
import './MultiSelectDropdown.css';

const MultiSelectDropdown = ({ 
  options, 
  selectedValues, 
  onChange, 
  placeholder = 'Select options...', 
  minSelections = 1,
  label = '',
  required = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleOption = (value) => {
    const newValues = selectedValues.includes(value)
      ? selectedValues.filter(v => v !== value)
      : [...selectedValues, value];
    
    // Ensure minimum selections
    if (newValues.length >= minSelections) {
      onChange(newValues);
    }
  };

  const getSelectedLabels = () => {
    const selected = options.filter(opt => selectedValues.includes(opt.value));
    if (selected.length === 0) return placeholder;
    if (selected.length === 1) return selected[0].label;
    if (selected.length === options.length) return 'All games selected';
    return `${selected.length} games selected`;
  };

  return (
    <div className="multi-select-dropdown" ref={dropdownRef}>
      {label && <label className="multi-select-label">{label}{required && ' *'}</label>}
      
      <div 
        className={`multi-select-header ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="multi-select-value">{getSelectedLabels()}</span>
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} dropdown-arrow`}></i>
      </div>

      {isOpen && (
        <div className="multi-select-options">
          {options.map(option => (
            <div 
              key={option.value}
              className={`multi-select-option ${selectedValues.includes(option.value) ? 'selected' : ''}`}
              onClick={() => toggleOption(option.value)}
            >
              <input
                type="checkbox"
                checked={selectedValues.includes(option.value)}
                onChange={() => {}}
                className="option-checkbox"
              />
              <div className="option-content">
                {option.icon && <i className={option.icon} style={{ color: option.color }}></i>}
                <span className="option-label">{option.label}</span>
                {option.description && (
                  <span className="option-description">{option.description}</span>
                )}
              </div>
            </div>
          ))}
          
          {minSelections > 0 && (
            <div className="multi-select-footer">
              <small>Select at least {minSelections} option{minSelections > 1 ? 's' : ''}</small>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;